/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2022-10-31 09:47:28
 * @Description: 
 */
import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/modules/effect-coverflow/effect-coverflow.scss";
import 'swiper/swiper.scss';
import "swiper//modules/navigation/navigation.scss";
import "swiper/modules/pagination/pagination.scss";

// import required modules
import { Pagination } from "swiper";
import urls from "src/constant/url";
import "./FTNoImageLinkToAIGC.scss"
import { getAIGCLink } from "src/utils";
export default function FTNoImageLinkToAIGC() {
  const list = [
    {
      image: urls.assetsUrl + "/img/aigc/banner-text.jpg",
      url: getAIGCLink("textToImage")
    },
    {
      image: urls.assetsUrl + "/img/aigc/banner-photo.jpg",
      url: getAIGCLink("imageToImage")
    }
  ]
  const preventDefault = (e: any) => {
    e.preventDefault && e.preventDefault()
    e.stopPropagation && e.stopPropagation()
  }
  const handleClick = (e: any, value: any) => {
    preventDefault(e)
    window.open(value.url)
  }
  return (
    <>
    <div className="mySwiper">
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={1}
        initialSlide={1}
        loop={true}
        pagination={{
          bulletActiveClass: "bullet-active",
          bulletClass: "bullet-default"
        }}
        slideToClickedSlide={true}
        modules={[ Pagination ]}
      >
        {list.map((item: any) => {
          return <SwiperSlide key={item.image} onMouseDown={preventDefault} onClick={(e) => handleClick(e, item)}>
            <img src={item.image} alt="" />
          </SwiperSlide>
        })}
      </Swiper>
    </div>
    </>
  );
}
